<template>
  <div class="promotion">
    <div class="worp">
      <div class="p_left">
        <img src="@/assets/app.png" alt="" />
      </div>
      <div class="p_right">
        <div>
          <img src="@/assets/dllogo.png" alt="" />
        </div>
        <div class="p_code">
          <img src="@/assets/code.png" alt="" />
        </div>
        <div class="p_text">手机扫码下载科普中国APP</div>
        <div class="p_btn">
          <button type="text" class="pb_left">
            <a
              href="https://apps.apple.com/cn/app/id1114665048"
              target="_blank"
            >
              <span><i class="fa fa-apple"></i></span>
              <span>iPhone</span>
              <span>下载</span>
            </a>
          </button>
          <button type="text" class="pb_right">
            <a
              href="https://sj.qq.com/myapp/detail.htm?apkName=com.sevenplus.chinascience&info=B23404625FD2478FE48400E98D032590"
              target="_blank"
            >
              <span><i class="fa fa-android"></i></span>
              <span>Android</span>
              <span>下载</span>
            </a>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownloadApp",
};
</script>

<style lang="scss" scoped>
.promotion {
  max-width: 2560px;
  height: 1017px;
  background: url("~@/assets/bg.png") no-repeat center center;
  background-size: 2560px 1017px;

  .worp {
    width: 1540px;
    padding: 64px 0 0;
    margin: 0 auto;
    clear: both;

    .p_left {
      float: left;
    }

    .p_right {
      float: right;
      width: 858px;
      text-align: center;

      .p_code {
        width: 370px;
        height: 370px;
        margin: 40px auto 28px;
        border: 16px solid #d8d8d8;

        img {
          width: 100%;
          height: auto;
        }
      }

      .p_text {
        font-size: 30px;
        font-weight: 500;
        color: #333;
        letter-spacing: 1px;
      }

      .p_btn {
        button {
          width: 414px;
          height: 110px;
          margin: 80px 0 0;
          background: #f2304a;
          border: none;
          border-radius: 10px;

          a {
            font-size: 32px;
            font-weight: 500;
            line-height: 45px;
            color: #fff;
            text-decoration: none;

            span {
              margin: 0 5px;
            }
          }
        }

        .pb_left {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>
